<div class="w-75 px-4">
    <ng-container [formGroup]="customerEnvironmentDetails">
      <div *ngIf="!editAppreg">
        <kendo-formfield>
          <div class="d-grid gap-3">
              <div class="p-2 bg-light border">
                <span><b>Tenant Id:</b> {{appRegDetails.tenantId}}</span>
              </div>
          
              <div class="p-2 bg-light border">
                  <span><b>Client Id:</b> {{appRegDetails.appRegistrationId}}</span>
          
              </div>
  
          </div>
          </kendo-formfield>

          <div class="pt-2" *ngIf="showEditAppReg">
            <button
            class="k-button"
            kendoButton
            themeColor="primary"
            (click)="editMailboxAppReg()"
        >
            Edit Settings
        </button>
  
        </div>
      </div>
        <div class="d-grid gap-1" *ngIf = "editAppreg">

          <kendo-formfield orientation="horizontal" class="mt-0">
          <kendo-label [for]="TenantId" text="Tenant Id: "></kendo-label>
          <input
          formControlName="tenantId"
            kendoTextBox
            #TenantId
            required
          />
        </kendo-formfield>

          <kendo-formfield orientation="horizontal" class="mt-0">
          <kendo-label [for]="ClientId" text="Client Id: "></kendo-label>
          <input
          formControlName="appRegistrationId"
            kendoTextBox
            #ClientId
            required
          />
        </kendo-formfield>

        <div class="pt-2">
          <button
          class="k-button"
          kendoButton
          themeColor="primary"
          (click)="updateMailboxAppReg()"
      >
          Update Settings
      </button>

      </div>
      </div>
    </ng-container>
</div>